module.exports = __webpack_public_path__ + "static/media/p5ru.3c6aee5d.pdf";